// 内蔵みほんテキスト（著作権クリア済み・伝承・PD作品のみ）
// 未就学児向け4作品 + 低学年向け4作品

const BUILTIN_TEXTS = [
  // ── 未就学児向け（童謡・わらべうた） ──────────────────────
  {
    id: 'builtin_dendenmushi',
    title: 'でんでんむしむし',
    author: '伝承',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 0,
    genre: 'わらべうた',
    level: 'preschool',
    paragraphs: [
      [
        'でんでんむしむし　かたつむり',
        'おまえのあたまは　どこにある',
        'つのだせ　やりだせ　あたまだせ',
      ],
    ],
  },
  {
    id: 'builtin_donguri',
    title: 'どんぐりころころ',
    author: '青木存義',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 0,
    genre: '童謡',
    level: 'preschool',
    paragraphs: [
      [
        'どんぐりころころ　どんぶりこ',
        'おいけに　はまって　さあたいへん',
        'どじょうが　でてきて　こんにちは',
      ],
      [
        'ぼっちゃん　いっしょに　あそびましょう',
      ],
    ],
  },
  {
    id: 'builtin_usagitokame',
    title: 'もしもしかめよ',
    author: '石原和三郎',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 0,
    genre: '童謡',
    level: 'preschool',
    paragraphs: [
      [
        'もしもし　かめよ　かめさんよ',
        'せかいのうちに　おまえほど',
        'あゆみの　おそい　ものはない',
      ],
      [
        'どうして　そんなに　おそいのか',
      ],
    ],
  },
  {
    id: 'builtin_chocho',
    title: 'ちょうちょう',
    author: '伝承',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 0,
    genre: '童謡',
    level: 'preschool',
    paragraphs: [
      [
        'ちょうちょう　ちょうちょう',
        'なのはに　とまれ',
        'なのはが　いやなら　さくらに　とまれ',
      ],
    ],
  },

  // ── 低学年向け（昔話） ─────────────────────────────────────
  {
    id: 'builtin_momotaro',
    title: 'ももたろう',
    author: '日本の昔話',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 1,
    genre: '昔話',
    level: 'early',
    paragraphs: [
      [
        'むかしむかし、おじいさんと　おばあさんが　すんでいました。',
        'おばあさんが　かわで　せんたくを　していると、おおきな　ももが　ながれてきました。',
        'ももを　わると、なかから　げんきな　おとこのこが　うまれました。',
      ],
      [
        'ふたりは「ももたろう」と　なまえを　つけました。',
        'ももたろうは　いぬと　さると　きじを　なかまにして、おにがしまへ　むかいました。',
        'おにを　やっつけて、たからものを　もって　ぶじに　かえりました。',
      ],
    ],
  },
  {
    id: 'builtin_omusubi',
    title: 'おむすびころりん',
    author: '日本の昔話',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 1,
    genre: '昔話',
    level: 'early',
    paragraphs: [
      [
        'むかしむかし、やさしい　おじいさんが　いました。',
        'やまで　おむすびを　たべようと　すると、ころころと　ころがって　あなに　おちました。',
        'あなの　なかから「おむすびころりん　すっとんとん」と　うたが　きこえてきました。',
      ],
      [
        'おじいさんが　のぞいてみると、ねずみたちが　おどっていました。',
        'ねずみたちは　おじいさんに　おれいの　たからものを　わたしました。',
        'おじいさんは　にこにこしながら　うちへ　かえりました。',
      ],
    ],
  },
  {
    id: 'builtin_sarukani',
    title: 'さるかにがっせん',
    author: '日本の昔話',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 1,
    genre: '昔話',
    level: 'early',
    paragraphs: [
      [
        'むかしむかし、かにが　おにぎりを　もっていました。',
        'さるが「かきのたねと　かえてあげよう」と　いいました。',
        'かには　たねを　うえて、いっしょうけんめい　そだてました。',
      ],
      [
        '「はやく　なれ、かきのき」と　うたいながら　そだてました。',
        'きが　そだって　かきの　みが　なりました。',
        'かには　なかまと　いっしょに　さるに　かちました。',
      ],
    ],
  },
  {
    id: 'builtin_kobutori',
    title: 'こぶとりじいさん',
    author: '日本の昔話',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 1,
    genre: '昔話',
    level: 'early',
    paragraphs: [
      [
        'むかしむかし、ほっぺに　こぶの　ある　おじいさんが　いました。',
        'もりで　おにたちに　であいました。',
        'おじいさんが　たのしそうに　おどると、おにたちは　よろこびました。',
      ],
      [
        '「また　おどりに　きてくれ」と　いって、おにたちは　こぶを　とってくれました。',
        'おじいさんは　こぶが　なくなって、うれしく　かえりました。',
      ],
    ],
  },
  {
    id: 'builtin_taketori',
    title: '竹取物語',
    author: '作者不詳',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 4,
    genre: '古典',
    level: 'classic',
    paragraphs: [
      [
        'いまはむかし、たけとりのおきなといふものありけり。',
        'のやまにまじりてたけをとりつつ、よろづのことにつかひけり。',
        'なをば、さぬきのみやつことなむいひける。',
      ],
    ],
  },
  {
    id: 'builtin_tsurezure',
    title: '徒然草（序段）',
    author: '兼好法師',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 4,
    genre: '古典',
    level: 'classic',
    paragraphs: [
      [
        'つれづれなるままに、ひぐらし、すずりにむかひて、',
        'こころにうつりゆくよしなしごとを、そこはかとなくかきつくれば、',
        'あやしうこそものぐるほしけれ。',
      ],
    ],
  },
  {
    id: 'builtin_makura',
    title: '枕草子（春はあけぼの）',
    author: '清少納言',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 4,
    genre: '古典',
    level: 'classic',
    paragraphs: [
      [
        'はるはあけぼの。やうやうしろくなりゆくやまぎは、',
        'すこしあかりて、むらさきだちたるくものほそくたなびきたる。',
      ],
    ],
  },
  {
    id: 'builtin_heike',
    title: '平家物語（冒頭）',
    author: '作者不詳',
    publisher: 'builtin',
    publisher_label: 'みほん',
    grade: 4,
    genre: '古典',
    level: 'classic',
    paragraphs: [
      [
        'ぎおんしょうじゃのかねのこえ、しょぎょうむじょうのひびきあり。',
        'しゃらそうじゅのはなのいろ、じょうしゃひっすいのことわりをあらはす。',
      ],
    ],
  },
];

export default BUILTIN_TEXTS;
